import styled from '@emotion/styled';

export const LogoutBtn = styled.button`
	background-color: ${p => p.theme.colors.transparent};
	border: none;
	padding: 0px;
	font-weight: 300;
	font-size: 14px;
	text-decoration: underline;
	color: ${p => p.theme.colors.textMain};
`;
